function getLastTld() {
  const regex = window.location.hostname.match(/\.([^.]+)$/);
  return regex ? regex[1] : 'ar';
}

export function getCountryIDFromTld(hostname) {
  const tld = getLastTld(hostname);
  switch (tld) {
    case 'ar':
      return 10;
    case 'cl':
      return 228;
    case 'es':
      return 232;
    case 'mx':
      return 231;
    case 'pe':
      return 229;
    case 'uy':
      return 227;
    default:
      return 10;
  }
}

export function getReservationsEmailFromTld() {
  const tld = getLastTld();
  switch (tld) {
    case 'ar':
      return 'reservas@bigbox.com.ar';
    case 'cl':
      return 'reservas@bigbox.cl';
    case 'es':
      return 'reservas@bigbox.es';
    case 'mx':
      return 'reservas@bigbox.com.mx';
    case 'co':
      return 'reservas@bigbox.com.co';
      case 'pe':
      return 'reservas@bigbox.com.pe';
    case 'uy':
      return 'reservas@bigbox.com.uy';
    default:
      return 'reservas@bigbox.com.ar';
  }
}

export default getLastTld;
